import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ApifirstService } from 'src/app/service/apifirst.service';

@Component({
  selector: 'app-manageuser',
  templateUrl: './manageuser.component.html',
  styleUrls: ['./manageuser.component.scss'],
  encapsulation: ViewEncapsulation.None,
  styles: [`
    .dark-modal .modal-content {
      background-color: #292b2c;
      color: white;
    }
    .dark-modal .close {
      color: white;
    }
    .light-blue-backdrop {
      background-color: #5cb3fd;
    }
  `]
})
export class ManageuserComponent implements OnInit {
  public showhideblock1 = false;
  public datapresent = false;
  public flagset = false;
  public username: any = '';
  public lastName: any = '';
  public errormsg: any = '';
  public apierrormsg: any = '';
  public staff: string = "0";
  public getuserdetaildata: any;
  public getselectuserdetailavail: string[] = [];
  public getselectuserdetailselect: string[] = [];
  public getselectqualifieduserdetails: any = [];
  public setuserroledetailavail: any;
  public setuserroledetailselect: any;
  public email = '';
  public userfullname = '';
  public surname = '';
  public uname = '';
  public uType = '';
  public countrycode = '';
  public userselect: string[] = [];
  public useravail: string[] = [];
  public errormsg1: any = '';
  public country: any = '';
  public rolesdetails: any = '';
  public language: any = '';

  constructor(private modalService: NgbModal, private service: ApifirstService, private translate: TranslateService) { }

  ngOnInit(): void { }
  /*api to get user details*/
  getUserDetailsInput(longcontent: any) {
    this.showhideblock1 = false
    if ((this.username == null || this.username == undefined || this.username == '') &&
      (this.lastName == null || this.lastName == undefined || this.lastName == '')) {
      this.errormsg = this.translate.instant('Please enter either a Username or a Lastname');
    }
    else {
      if (this.username == null) { this.username = '' }
      if (this.lastName == null) { this.lastName = '' }
      if (this.staff == null) { this.staff = "0" }
      this.errormsg = "";
      let manageuserdetail = {
        "username": this.username,
        "lastName": this.lastName,
        "userType": this.staff
      }
      this.service.searchUserDetails(manageuserdetail).subscribe((datasearchUserDetails) => {
        this.getuserdetaildata = datasearchUserDetails.rows;
        this.flagset = false
      }, (error) => {
        this.apierrormsg = this.translate.instant('No results were found for your search')
        this.flagset = true
      })
      this.modalService.open(longcontent, { centered: true });
    }
  }
  /*function called to get the details from get user api*/
  getUserRoleDetails(usename: string, user: string, email: string, usertype: string, surname: string,
    countrycode: string, language: string) {
    this.showhideblock1 = false
    this.userfullname = user
    this.surname = surname
    this.email = email
    this.uname = usename
    this.uType = usertype
    this.countrycode = countrycode
    this.language = language
  }
  /*api to get the user roles */
  selectUserDetails() {
    if (this.uname == '' || this.uname == null || this.uname == undefined) {
      this.showhideblock1 = false
    }
    else {
      this.showhideblock1 = true
    }
    let getselectuserdetails =
    {
      "username": this.uname,
      "userType": this.uType
    }
    this.service.getUserRoleDetails(getselectuserdetails).subscribe(
      (datagetUserRoleDetails) => {
        this.getselectuserdetailavail = datagetUserRoleDetails.availableUserRoles
        this.getselectuserdetailselect = datagetUserRoleDetails.selectedUserRoles
      })
    // this.setQualifiedUserDetails();
  }
  /*functions to do required operations*/
  closetabs() {
    this.showhideblock1 = false
    /*clearing all the data*/
    this.getuserdetaildata = []
    this.username = ''
    this.lastName = ''
    this.staff = "0"
    this.userfullname = ''
    this.surname = ''
    this.email = ''
    this.uname = ''
    this.uType = ''
    this.countrycode = ''
    this.getselectuserdetailavail = []
    this.getselectuserdetailselect = []
    this.getselectqualifieduserdetails = []
  }
  addall() {
    for (let d of this.getselectuserdetailavail) {
      this.getselectuserdetailselect.push(d);
    }
    this.getselectuserdetailavail = [];
  }
  add() {
    let user = this.useravail.map((user) => user);
    this.getselectuserdetailavail = this.getselectuserdetailavail.filter((value) => {
      return user.indexOf(value) === -1;
    })
    this.getselectuserdetailavail;
    for (let usr of this.useravail) {
      this.getselectuserdetailselect.push(usr);
    }
  }
  removeRole() {
    let user = this.userselect.map((user) => user);
    this.getselectuserdetailselect = this.getselectuserdetailselect.filter((value) => {
      return user.indexOf(value) === -1;
    })
    this.getselectuserdetailselect;
    for (let usr of this.userselect) {
      this.getselectuserdetailavail.push(usr);
    }
  }
  removeall() {
    for (let d of this.getselectuserdetailselect) {
      this.getselectuserdetailavail.push(d);
    }
    this.getselectuserdetailselect = [];
  }
  /* api to set the user roles */
  setUserRoleDetails() {
    let setuserdetails = {
      "username": this.uname,
      "userType": this.uType,
      "availableUserRoles": this.getselectuserdetailavail,
      "selectedUserRoles": this.getselectuserdetailselect
    }
    this.service.setUserRoleDetails(setuserdetails).subscribe(
      (datagetUserRoleDetails) => {
        this.getselectuserdetailavail = datagetUserRoleDetails.availableUserRoles;
        this.getselectuserdetailselect = datagetUserRoleDetails.selectedUserRoles;
      })
  }
  /* Api to get the qualified user details */
  setQualifiedUserDetails() {
    const setqualifieduserdetail = {
      "qualifier": this.countrycode
    }
    this.service.setQualifiedUserDetails(setqualifieduserdetail).subscribe(
      (datagetqualifiedUserRoleDetails) => {
        this.getselectqualifieduserdetails = datagetqualifiedUserRoleDetails
        for (let i in this.getselectqualifieduserdetails) {
          this.rolesdetails = this.getselectqualifieduserdetails[i].roleName;
        }
      })
  }
}

